import { ReactNode } from 'react'
import cx from 'classnames'
import { GlassSurface, Stack, Text } from '~m/designSystem'
import styles from './SyncActionBar.module.css'

export interface SyncActionBarProps {
  /** Summary text on the left, e.g. what applying will do */
  note?: ReactNode
  /** Action buttons, shown on the right */
  children?: ReactNode
  /** Additional CSS class */
  className?: string
}

/**
 * A sticky footer bar that summarises the pending sync and holds
 * the primary actions (apply / cancel). Built on a GlassSurface
 * panel so it reads as frosted glass over the scrolling list.
 */
export function SyncActionBar({
  note,
  children,
  className,
}: SyncActionBarProps) {
  return (
    <GlassSurface
      variant="panel"
      className={cx(styles.SyncActionBar, className)}
    >
      {note != null && (
        <Text
          variant="body"
          component="div"
          className={styles.SyncActionBar__note}
        >
          {note}
        </Text>
      )}
      {children != null && (
        <Stack direction="row" gap={1.5}>
          {children}
        </Stack>
      )}
    </GlassSurface>
  )
}
